module.exports = __webpack_public_path__ + "img/lacnic.62fcc03a.png";